import { render, staticRenderFns } from "./PanicBuy.vue?vue&type=template&id=497f6196&scoped=true&"
import script from "./PanicBuy.vue?vue&type=script&lang=js&"
export * from "./PanicBuy.vue?vue&type=script&lang=js&"
import style0 from "./PanicBuy.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PanicBuy.vue?vue&type=style&index=1&id=497f6196&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497f6196",
  null
  
)

export default component.exports